// extracted by mini-css-extract-plugin
export default {"root":"wGlgNebWkRDwKEGEXxtT","dollar":"JN4NPc7zzsp26YVAjHHM","per-hour":"YQGYMtBvlKHCNQ41RRfr","perHour":"YQGYMtBvlKHCNQ41RRfr"};